module.exports = __webpack_public_path__ + "static/FaroWeb-RegularLucky-3b9b3b0fc7d2551a7cbd157f92c421f2.woff";